<template>
    <div class="wineguide-container">
        <ul class="v-breadcrumbs vindome-breadcrumbs">
            <li class="v-breadcrumbs__item__home">
                <nuxt-link :to="localePath('/')" class="v-breadcrumbs__item">Vindome</nuxt-link>
            </li>
            <li class="v-breadcrumbs__divider">&gt;</li>
            <li class="v-breadcrumbs__item__home">
                <nuxt-link :to="localePath('/wine-guide')" class="v-breadcrumbs__item">{{ $t("home-top4") }}</nuxt-link>
            </li>
            <li class="v-breadcrumbs__divider">&gt;</li>
            <li>
                <span class="v-breadcrumbs__item">Spain</span>
            </li>
        </ul>
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <div @click="goToPrev()" class="wine-guide-back"></div>
                        {{ $t("regions") }}
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/spain/priorat')">Priorat
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/spain/ribera-del-duero')">Ribera del Duero
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <div @click="goToPrev()" class="wine-guide-back"></div>
                        {{ $t("regions") }}
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Spain Fine Wines</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Per i profani, la Spagna è in ritardo rispetto ai suoi vicini europei nella posta in gioco del vino pregiato.
                        Oscurato sia dalla Francia che dall'Italia, il paese ha pochi produttori di giganti, quindi potresti esserlo
                        perdonato che quando si tratta di investire nel buon vino spagnolo, non ottieni molto successo per il tuo
                        secchio.
                        <br><br>
                        Tuttavia, massicci investimenti da parte del governo spagnolo insieme al cambiamento del consumatore
                        la tavolozza dei vini più leggeri ha riportato di moda il patrimonio culturale spagnolo. Attorno
                        nello stesso periodo l'influente Robert Parker ha assegnato ufficialmente a due vini spagnoli punteggi molto alti
                        riportando in vita l'industria vinicola del paese.
                        <br><br>
                        Così investitori ambiziosi iniziarono a guardare il vino spagnolo con occhi nuovi; hanno preso un aumento
                        interesse per i vitigni (sia per i vini rossi che per i bianchi), le diverse regioni vinicole e
                        le abilità enologiche delle bodegas. Hanno studiato l'altitudine dei vigneti, realizzando
                        il ruolo che questo svolge nella viticoltura spagnola; il fatto che la maggior parte dei vigneti sono stati piantati a
                        oltre i 600 metri significavano giornate lunghe e notti più fresche perfette per produrre vini con buoni livelli di
                        acidità e colore tutt'intorno. Con solo quei due punteggi, Parker aveva iniziato il vino spagnolo
                        rivoluzione.
                        <br><br>
                        Sebbene l'industria vinicola spagnola stia ancora emergendo, non possiamo davvero considerarla un vino del nuovo mondo.
                        Come il resto d'Europa, è caduto vittima della fillossera che ha devastato le viti durante la tarda età
                        19esimo secolo. Seguito da due guerre mondiali e una civile, non c'è da meravigliarsi che gli spagnoli bene
                        l'industria del vino ha impiegato un po' più di tempo rispetto ai suoi concorrenti per recuperare il suo mojo. Tuttavia, lì
                        sono certe regioni e produttori che ora stanno lavorando in modo così spettacolare, possiamo perdonarli
                        il loro passato a scacchi.
                    </div>

                    <div class="howto-title">Ribera del Duero</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Una di queste regioni è Ribera del Duero, situata nel nord del paese. Trovato in Castilla y
                        Leon, a circa due ore a nord di Madrid, la regione è lunga circa 70 miglia e corre
                        lungo il fiume Duero. Ha anche un terreno sorprendentemente semi-arido mentre le enormi differenze
                        in elevazione, suolo, esposizione e naturalmente savoir faire non fanno due vini uguali. Era anche
                        nominata Regione dell'anno da Wine Enthusiast nel 2012.
                        <br><br>
                        Prendiamo ad esempio i suoi due protagonisti: Pingus è considerato uno dei vini più individuali in circolazione
                        il mercato. La sua singolarità è la sua forza, e non sarebbe stato possibile in uno dei
                        altre regioni vinicole della Spagna. I vini Tempranillo della vecchia vite sono grandi, audaci e strutturati, e lo sono
                        trattato con sensibilità e amore dall'enologo di Pingus Peter Sisseck, che ha puntato i riflettori
                        sulla regione. E sì, è un Pingus è uno dei puntatori perfetti di Parker.
                        <br><br>
                        L'altra superstar della regione è completamente diversa, sottolineando la grande varietà che ha
                        Ribera del Duero è capace di. Unico di Vegas Sicilia ha mantenuto il tradizionalismo del vecchio mondo che
                        ne ha fatto un attore mondiale da oltre 150 anni. Le sue proporzioni epiche sono illimitate, offrendo
                        potenziale di cantina senza pari, sia che tu stia cercando di bere o investire. Entrambi i vini sono a
                        essere risparmiato per una giornata di pioggia - a circa € 800 a bottiglia per Pingus (Q3 2019, certa annata
                        come il 2014 sono molto più alti) e oltre € 400 per Unico, sembra che ciò che Ribera del Duero
                        manca di quantità di vino pregiato, compensa con la qualità.
                    </div>

                    <div class="howto-title">Priorità</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Come molte cose piccole, Priorat è bello. E non intendiamo solo il terreno.
                        Situato un po' a sud di Barcellona, se la domanda è grandi, audaci, vini rossi allora Priorat è quello che fa per voi
                        risposta. Il terreno è accidentato e secco, il clima è soleggiato e i vini sono così unici che Parker ha
                        dato il suo perfetto 100 almeno ai vini della regione in almeno tre recenti occasioni.
                        <br><br>
                        Nonostante le radici vinicole della regione risalgano al 1163, Priorat è stato tristemente trascurato
                        per gran parte del XX secolo, a causa sia del regime fascista dell'epoca che del
                        annientamento della vite da parte della fillossera nel XIX secolo. I vigneti di Priorat sono diminuiti da 5.000
                        ettari (e ricordate, questa è una piccola regione di meno di 20.000 ettari) a soli 1.500
                        ettari nel 1989.
                        <br><br>
                        Tuttavia, tutto è cambiato con l'arrivo di René Barbier, che ha introdotto tecniche francesi e
                        uva alla regione dimenticata. Insieme al suo team di enologi appassionati, enologi e
                        sostenitori, hanno creato i cinque “Clos”, cioè vigneti murati come in Francia. Questi originali
                        famose cinque etichette, Clos Mogador, Clos Dofí (ora Finca Dofí), Clos de L'Obac, Clos Martinet,
                        e Clos Erasmus hanno ricevuto tutti un'intensa attenzione sia in patria che all'estero. Vini eccezionali e
                        i punteggi più alti sono naturalmente seguiti. Priorat è ora piantato con oltre 1.900 ettari e ne ha oltre 100
                        cantine (e quasi 600 produttori). Bravo a Barbier, il cui effetto Lazurus ha cambiato il volto di
                        Vinificazione spagnola per sempre.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Erlesene Weine aus Spanien</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Für den Laien hinkt Spanien bei den guten Weinen seinen europäischen Nachbarn hinterher.
                        Das Land, das sowohl von Frankreich als auch von Italien überschattet wird, hat nur wenige Produzenten von Giganten, das könnte also so sein
                        Ich verzeihe Ihnen, dass Sie bei der Investition in guten spanischen Wein nicht viel davon bekommen
                        Bock.
                        <br><br>
                        Allerdings gehen mit der Veränderung der Verbraucherlage auch massive Investitionen der spanischen Regierung einher
                        Die Palette der leichteren Weine hat das kulturelle Erbe Spaniens wieder in Mode gebracht. Um ungefähr
                        Gleichzeitig verlieh der einflussreiche Robert Parker offiziell zwei Weinen aus Spanien sehr hohe Bewertungen
                        die Weinindustrie des Landes von den Toten auferstehen zu lassen.
                        <br><br>
                        So begannen ehrgeizige Investoren, spanischen Wein mit neuen Augen zu betrachten; Sie nahmen eine Erhöhung
                        Interesse an den Rebsorten (sowohl für Rot- als auch für Weißweine), den verschiedenen Weinregionen und
                        die Winzerkunst der Bodegas. Sie untersuchten die Höhe der Weinberge und stellten fest
                        welche Rolle dies im spanischen Weinbau spielt; die Tatsache, dass die meisten Weinberge gepflanzt wurden
                        Über 600 Meter bedeuteten lange Tage und kühlere Nächte, perfekt für die Herstellung von Weinen mit gutem Alkoholgehalt
                        Säure und Farbe rundherum. Mit nur diesen beiden Punkten hatte Parker den spanischen Wein gegründet
                        Revolution.
                        <br><br>
                        Obwohl Spaniens Weinindustrie noch im Entstehen begriffen ist, können wir ihn nicht wirklich als einen Wein der neuen Welt betrachten.
                        Wie das übrige Europa fiel es der Reblaus zum Opfer, die in den späten 1960er Jahren die Reben heimsuchte
                        19. Jahrhundert. Es ist kein Wunder, dass den Spaniern zwei Weltkriege und ein Bürgerkrieg folgten
                        Die Weinindustrie brauchte etwas länger als ihre Konkurrenten, um ihr Mojo zurückzugewinnen. Trotzdem da
                        Es gibt bestimmte Regionen und Produzenten, die jetzt so spektakulär arbeiten, dass wir ihnen verzeihen können
                        ihre bewegte Vergangenheit.
                    </div>

                    <div class="howto-title">Ribera del Duero</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Eine dieser Regionen ist Ribera del Duero im Norden des Landes. Gefunden in Kastilien
                        Leon, etwa zwei Stunden nördlich von Madrid, ist die Region etwa 70 Meilen lang und verläuft
                        entlang des Flusses Duero. Es hat auch ein überraschend halbtrockenes Gelände und große Unterschiede
                        Aufgrund der Höhenlage, des Bodens, der Lage und natürlich des Savoir-Faire gleicht kein Wein dem anderen. Es wurde auch
                        2012 zur Region des Jahres für Weinliebhaber gekürt.
                        <br><br>
                        Nehmen Sie zum Beispiel seine beiden Starspieler: Pingus gilt als einer der individuellsten Weine überhaupt
                        der Markt. Seine Einzigartigkeit ist seine Stärke und wäre in keinem dieser Länder möglich gewesen
                        andere Weinregionen Spaniens. Die Tempranillo-Weine aus alten Reben sind groß, kräftig und strukturiert, und das sind sie auch
                        Mit Sensibilität und Liebe behandelt von Pingus’ Winzer Peter Sisseck, der für Aufsehen gesorgt hat
                        auf die Region. Und ja, es ist ein Pingus, einer der perfekten Parker-Zeiger.
                        <br><br>
                        Der andere Superstar der Region ist völlig anders und unterstreicht die enorme Vielfalt
                        Ribera del Duero ist dazu fähig. Das Unico in Vegas Sicilia hat den Traditionalismus der alten Welt beibehalten
                        hat es seit über 150 Jahren zu einem Weltmarktführer gemacht. Seine epischen Ausmaße sind grenzenlos und bieten
                        beispielloses Lagerpotenzial, egal ob Sie ihn trinken oder investieren möchten. Beide Weine sind zu
                        Man sollte ihn sich jedoch für einen regnerischen Tag aufsparen – für rund 800 € pro Flasche für Pingus (3. Quartal 2019, bestimmter Jahrgang).
                        (wie 2014 sind viel höher) und mehr als 400 € für Unico, es scheint das zu sein, was Ribera del Duero
                        Der Mangel an erlesenen Weinen wird durch Qualität wettgemacht.
                    </div>

                    <div class="howto-title">Priorat</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Wie viele kleine Dinge ist Priorat wunderschön. Und damit meinen wir nicht nur das Gelände.
                        Etwas südlich von Barcelona gelegen, ist Priorat die richtige Wahl, wenn es um große, kräftige Rotweine geht
                        antworten. Das Gelände ist rau und trocken, das Klima ist sonnig und die Weine von Parker sind so einzigartig
                        Er erhielt in letzter Zeit mindestens drei Mal die Höchstnote 100 für Weine aus der Region.
                        <br><br>
                        Trotz der Wurzeln der Weinherstellung in der Region, die bis ins Jahr 1163 zurückreichen, wurde Priorat leider vernachlässigt
                        während eines Großteils des 20. Jahrhunderts, sowohl aufgrund des damaligen faschistischen Regimes als auch aufgrund der
                        Vernichtung der Reben durch Reblaus im 19. Jahrhundert. Die Weinberge des Priorats schrumpften von 5.000
                        Hektar (und denken Sie daran, dies ist eine kleine Region mit weniger als 20.000 Hektar) auf nur 1.500
                        Hektar im Jahr 1989.
                        <br><br>
                        Das änderte sich jedoch mit der Ankunft von René Barbier, der französische Techniken einführte
                        Trauben in die vergessene Region. Zusammen mit seinem Team aus leidenschaftlichen Winzern, Önologen und
                        Befürworter schufen die fünf „Clos“, also ummauerte Weinberge wie in Frankreich. Diese original
                        berühmte fünf Etiketten: Clos Mogador, Clos Dofí (heute Finca Dofí), Clos de L’Obac, Clos Martinet,
                        und Clos Erasmus erregten im In- und Ausland große Beachtung. Hervorragende Weine und
                        Highscores folgten natürlich. Priorat ist jetzt mit über 1.900 Hektar bepflanzt und hat über 100
                        Weingüter (und fast 600 Erzeuger). Bravo an Barbier, dessen Lazurus-Effekt das Gesicht veränderte
                        Spanische Weinherstellung für immer.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Vins fins d'Espagne</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Pour le profane, l'Espagne est en retard sur ses voisins européens dans les enjeux des vins fins.
                        Éclipsé par la France et l'Italie, le pays compte peu de producteurs de géants, vous pourriez donc être
                        pardonné que lorsqu'il s'agit d'investir dans du bon vin espagnol, vous n'en avez pas pour votre argent
                        mâle.
                        <br><br>
                        Cependant, les investissements massifs du gouvernement espagnol ainsi que le changement de consommation
                        palette de vins plus légers a remis à la mode le patrimoine culturel espagnol. Vers
                        dans le même temps, l'influent Robert Parker a donné à deux vins d'Espagne des notes très élevées, officiellement
                        ramener l'industrie viticole du pays d'entre les morts.
                        <br><br>
                        Ainsi, des investisseurs ambitieux ont commencé à regarder le vin espagnol avec un nouveau regard ; ils ont pris une augmentation
                        intérêt pour les cépages (aussi bien pour les vins rouges que blancs), les différentes régions viticoles et
                        le savoir-faire viticole des bodegas. Ils ont recherché l'altitude des vignes, se rendant compte
                        le rôle que cela joue dans la viticulture espagnole ; le fait que la plupart des vignes ont été plantées à
                        plus de 600 mètres signifiaient de longues journées et des nuits plus fraîches parfaites pour faire des vins avec de bons niveaux de
                        acidité et couleur tout autour. Avec seulement ces deux scores, Parker avait lancé le vin espagnol
                        révolution.
                        <br><br>
                        Alors que l'industrie viticole espagnole est encore émergente, nous ne pouvons pas vraiment la considérer comme un vin du nouveau monde.
                        Comme le reste de l'Europe, il a été victime du phylloxéra qui a ravagé la vigne à la fin
                        19ème siècle. Suivie de deux guerres mondiales et d'une guerre civile, il n'est pas étonnant que l'amende espagnole
                        l'industrie du vin a mis un peu plus de temps que ses concurrents à retrouver son mojo. Néanmoins, il y
                        sont certaines régions et certains producteurs qui travaillent aujourd'hui de manière si spectaculaire, on peut leur pardonner
                        leur passé mouvementé.
                    </div>

                    <div class="howto-title">Ribera del Duero</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        L'une de ces régions est Ribera del Duero, située dans le nord du pays. Trouvé en Castille y
                        Leon, à environ deux heures au nord de Madrid, la région mesure environ 70 miles de long et s'étend
                        le long du fleuve Duero. Il a également un terrain étonnamment semi-aride alors que les énormes différences
                        l'altitude, le sol, l'exposition et bien sûr le savoir-faire ne font pas deux vins identiques. C'était aussi
                        nommé Région de l'année par Wine Enthusiast en 2012.
                        <br><br>
                        Prenons par exemple ses deux acteurs vedettes : Pingus est considéré comme l'un des vins les plus individuels du
                        le marché. Sa singularité fait sa force, et n'aurait pas été possible dans l'un des
                        autres régions viticoles d'Espagne. Les vins Tempranillo de vieilles vignes sont gros, gras et texturés, et sont
                        traité avec sensibilité et amour par le vigneron de Pingus, Peter Sisseck, qui a braqué les projecteurs
                        sur la région. Et oui, c'est un Pingus est l'un des pointeurs parfaits de Parker.
                        <br><br>
                        L'autre superstar de la région est complètement différente, soulignant la grande variété qui
                        Ribera del Duero en est capable. L'Unico de Vegas Sicilia a conservé le traditionalisme de l'ancien monde qui
                        en a fait un acteur mondial depuis plus de 150 ans. Ses proportions épiques sont illimitées, offrant
                        un potentiel de garde inégalé que vous cherchiez à boire ou à investir. Les deux vins sont à
                        être économisé pour un jour de pluie - à environ 800 € la bouteille pour Pingus (Q3 2019, certains millésimes
                        comme 2014 sont beaucoup plus élevés) et plus de 400 € pour Unico, il semble que ce que Ribera del Duero
                        manque de bon vin en quantité, il se rattrape par la qualité.
                    </div>

                    <div class="howto-title">Priorat</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Comme beaucoup de petites choses, le Priorat est beau. Et nous ne parlons pas seulement du terrain.
                        Situé un peu au sud de Barcelone, si la question est grande, audacieuse, les vins rouges alors le Priorat est le
                        répondre. Le terrain est accidenté et sec, le climat est ensoleillé et les vins sont si uniques que Parker a
                        a donné sa note parfaite de 100 au moins à des vins de la région à au moins trois occasions récentes.
                        <br><br>
                        Malgré les racines viticoles de la région qui remontent à 1163, le Priorat a été malheureusement négligé
                        pendant une grande partie du XXe siècle, en raison à la fois du régime fasciste de l'époque et de la
                        anéantissement de la vigne par le phylloxéra au XIXe siècle. Les vignobles du Priorat ont diminué de 5 000
                        hectares (et rappelez-vous, c'est une petite région de moins de 20 000 hectares) à seulement 1 500
                        hectares en 1989.
                        <br><br>
                        Cependant, tout cela a changé avec l'arrivée de René Barbier, qui a introduit les techniques françaises et
                        raisins vers la région oubliée. Avec son équipe de vignerons passionnés, œnologues et
                        défenseurs, ils créèrent les cinq « Clos », c'est-à-dire des vignobles clos de murs comme en France. Ces originaux
                        célèbres cinq étiquettes, Clos Mogador, Clos Dofí (aujourd'hui Finca Dofí), Clos de L'Obac, Clos Martinet,
                        et Clos Erasmus ont tous reçu une attention intense tant au pays qu'à l'étranger. Des vins exceptionnels et
                        des scores élevés ont naturellement suivi. Le Priorat est aujourd'hui planté de plus de 1 900 hectares et compte plus de 100
                        vignerons (et près de 600 viticulteurs). Bravo à Barbier, dont l'effet Lazurus a changé le visage de
                        La viticulture espagnole pour toujours.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Spain Fine Wines</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        To the layperson, Spain lags behind its European neighbours in the fine wine stakes.
                        Overshadowed by both France and Italy, the country has few producers of giants, so you could be
                        forgiven that when it comes to investing in Spanish fine wine, you don’t get much bang for your
                        buck.
                        <br><br>
                        However, massive investment from the Spanish government along with the change in consumer
                        palette for lighter wines has brought Spain&#39;s cultural heritage back into fashion. At around
                        the same time influential Robert Parker gave two wines from Spain very high scores, officially
                        bringing the country’s wine industry back from the dead.
                        <br><br>
                        Thus ambitious investors began looking at Spanish wine with new eyes; they took an increased
                        interest in the grape varieties (for both red and white wines), the different wine regions and
                        the winemaking skills of the bodegas. They researched the altitude of the vineyards, realising
                        the part that this plays in Spanish viticulture; the fact that most vineyards were planted at
                        over 600 metres meant long days and cooler nights perfect for making wines with good levels of
                        acidity and colour all around. With just those two scores, Parker had started the Spanish wine
                        revolution.
                        <br><br>
                        While Spain’s wine industry is still emerging, we cannot really consider it a new world wine.
                        Like the rest of Europe, it fell victim to the phylloxera bug that ravaged vines during the late
                        19th century. Followed by two world and one civil war, it is no wonder that the Spanish fine
                        wine industry took a bit longer than its competitors to get its mojo back. Nevertheless, there
                        are certain regions and producers that are now working so spectacularly, we can forgive them
                        their chequered past.
                    </div>

                    <div class="howto-title">Ribera del Duero</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        One such region is Ribera del Duero, located in the north of the country. Found in Castilla y
                        Leon, roughly two hours north of Madrid, the region is approximately 70 miles long and runs
                        along the River Duero. It also has a surprisingly semi-arid terrain while the huge differences
                        in elevation, soil, exposure and of course savoir faire make no two wines the same. It was also
                        named Wine Enthusiast’s Region of the Year in 2012.
                        <br><br>
                        Take for example its two star players: Pingus is considered one of the most individual wines on
                        the market. Its singularity is its strength, and would not have been possible in one of the
                        other wine regions of Spain. The old-vine Tempranillo wines are big, bold and textured, and are
                        treated with sensitivity and love by Pingus’ winemaker Peter Sisseck, who has shone a spotlight
                        on the region. And yes, it’s a Pingus is one of the Parker perfect pointers.
                        <br><br>
                        The other superstar of the region is completely different, underlining the vast variety that
                        Ribera del Duero is capable of. Vegas Sicilia’s Unico has kept the old-world traditionalism that
                        has made it a world-player for over 150 years. Its epic proportions are limitless, offering
                        unparalleled cellaring potential whether you are looking to drink or invest. Both wines are to
                        be saved for a rainy day though - at around €800 a bottle for Pingus (Q3 2019, certain vintage
                        like 2014 are much higher) and upwards of €400 for Unico, it appears that what Ribera del Duero
                        lacks in fine wine quantity, it makes up for with quality.
                    </div>

                    <div class="howto-title">Priorat</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Like many things that are small, Priorat is beautiful. And we don&#39;t just mean the terrain.
                        Located a little south of Barcelona, if the question is big, bold, red wines then Priorat is the
                        answer. Terrain is rugged and dry, climate is sunny, and wines are so unique that Parker has
                        given his perfect 100 at least to wines from the region on at least three recent occasions.
                        <br><br>
                        Despite the region’s winemaking roots that stretch back to 1163, Priorat was sadly neglected
                        throughout much of the 20th century, due both to the fascist regime of the time and the
                        annihilation of vines by phylloxera in the 19th century. Priorat’s vineyards dwindled from 5,000
                        hectares (and remember, this is a small region of fewer than 20,000 hectares) to just 1,500
                        acres in 1989.
                        <br><br>
                        However, all that changed with the arrival of René Barbier, who introduced French techniques and
                        grapes to the forgotten region. Together with his team of passionate winemakers, oenologists and
                        advocates, they created the five “Clos”, i.e. walled vineyards such as in France. These original
                        famous five labels, Clos Mogador, Clos Dofí (now Finca Dofí ), Clos de L’Obac, Clos Martinet,
                        and Clos Erasmus all received intense attention both at home and abroad. Outstanding wines and
                        high scores naturally followed. Priorat is now planted with over 1,900 hectares and has over 100
                        wineries (and nearly 600 growers). Bravo to Barbier, whose Lazurus effect changed the face of
                        Spanish winemaking forever.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Spain",
    head: {
        title: 'Spain fine wine | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Explore the world of Spanish fine wines - From Rioja to Priorat, discover exceptional reds, whites, and rosés crafted by renowned wineries across Spain. Buy online now and experience the essence of Spain in every bottle.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Please choose', src: '#'},
            items: [
                {report: 'Priorat', src: '/wine-guide/spain/priorat'},
                {report: 'Ribera del Duero', src: '/wine-guide/spain/ribera-del-duero'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
            this.$router.push({path: a.src});
        },
        goToPrev() {
            this.$router.go(-1);
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover {
    border-color: #024E7B;
    background: #E5EDF2;
}


</style>
